import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import { useAcknowledgementHistory } from '../../hooks/useAcknowledgementHistory'

export interface AcknowledgementHistoryProps {
  userId: string
}

/** Human-readable labels for clause identifiers */
const CLAUSE_LABELS: Record<string, string> = {
  terms_and_conditions_signup: 'Terms & Conditions (Signup)',
  indemnity_s4_2: 'Indemnity (Section 4.2)',
  liability_disclaimer_s4_1: 'Liability Disclaimer (Section 4.1)',
  user_conduct_s5: 'User Conduct (Section 5)'
}

const AcknowledgementHistory = ({ userId }: AcknowledgementHistoryProps) => {
  const { records, loading, error } = useAcknowledgementHistory(userId)

  if (loading) {
    return (
      <Box display='flex' justifyContent='center' py={3}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  if (error) {
    return <Alert severity='error'>{error}</Alert>
  }

  if (records.length === 0) {
    return (
      <Typography color='text.secondary'>
        No acknowledgement records found.
      </Typography>
    )
  }

  return (
    <TableContainer component={Paper} variant='outlined'>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Clause</TableCell>
            <TableCell>Submission #</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record, index) => (
            <TableRow key={`${record.id}-${index}`}>
              <TableCell>
                {record.timestamp.toLocaleDateString('en-AU', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </TableCell>
              <TableCell>
                {CLAUSE_LABELS[record.clauseId] ?? record.clauseId}
              </TableCell>
              <TableCell>{record.submissionNumber ?? '—'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default AcknowledgementHistory
